import Big from 'big.js'

export default function toStripeAmountNumber(number: Big | number | string) {
  return Big(number).mul(100).toNumber()
}
